import Vue from 'vue';

const AudioPlayer = new Vue({
  data() {
    return {
      audio: undefined,
      audioUrl: undefined,
      baseAudio: new Audio(),
      durationInMicroSeconds: undefined,
      replaySrc: undefined,
      needReplay: false,
      needPlayExpressionSound: false,
      expressionSrc: undefined,
      isMicAudio: false,
      isTeachbot: false,
      previousSoundSrc: undefined,
      savePreviousSound: false,
    };
  },
  methods: {
    init(options) {
      this.expressionSrc = undefined;
      this.needPlayExpressionSound = false;
      this.needReplay = false;

      const audioUrl = options.audioUrl;
      const volume = options.volume !== undefined ? options.volume : 1;
      const playbackRate = options.playbackRate !== undefined ? options.playbackRate : 1;
      const saveReplaySrc = options.saveReplaySrc;
      const needReplay = options.needReplay;
      const needPlayExpressionSound = options.needPlayExpressionSound;
      const expressionSrc = options.expressionSrc;
      const isMicAudio = options.isMicAudio;
      const isTeachbot = options.isTeachbot;
      const savePreviousSound = options.savePreviousSound;

      if (savePreviousSound && savePreviousSound === true) {
        this.savePreviousSound = true;
        this.previousSoundSrc = this.baseAudio.src;
      }

      this.baseAudio.src = audioUrl;
      if (saveReplaySrc && saveReplaySrc === true) {
        this.replaySrc = audioUrl;
      }

      if (needReplay && needReplay === true) {
        this.needReplay = needReplay;
      } else {
        this.needReplay = false;
      }

      if (needPlayExpressionSound && needPlayExpressionSound === true && !needReplay) {
        this.needPlayExpressionSound = needPlayExpressionSound;
        this.expressionSrc = expressionSrc;
      }

      if (isMicAudio && isMicAudio === true) {
        this.isMicAudio = true;
      } else {
        this.isMicAudio = false;
      }

      if (isTeachbot && isTeachbot === true) {
        this.isTeachbot = true;
      } else {
        this.isTeachbot = false;
      }

      this.baseAudio.playbackRate = playbackRate;
      this.baseAudio.volume = volume;
      this.baseAudio.onended = this.playEnded;
      if (options.needDuration) {
        this.baseAudio.onloadedmetadata = () => {
          this.durationInMicroSeconds = this.baseAudio.duration * 1000;
          this.$emit('durationLoaded');
        };
      }
    },
    play(options) {
      this.baseAudio.pause();
      const currentTime = options && options.currentTime ? options.currentTime : 0;
      const source = options && options.source ? options.source : undefined;

      if (source) {
        this.baseAudio.src = source;
      }

      if (currentTime > 0) {
        this.baseAudio.currentTime = currentTime;
      }

      this.baseAudio.play().catch((e) => {
        if (this.isTeachbot) {
          this.$eventBus.$emit('TeachbotPlayError', e);
        }
        console.log(e);
      });
    },
    pause() {
      if (this.baseAudio) {
        this.baseAudio.pause();
      }
    },
    playEnded() {
      this.baseAudio.pause();
      this.$emit('playEnded');
      if (this.needReplay) {
        this.replaySound();
      }
      if (this.needPlayExpressionSound && this.needPlayExpressionSound === true && this.expressionSrc !== undefined) {
        this.baseAudio.src = this.expressionSrc;
        this.baseAudio.play().catch((e) => {
          this.baseAudio.src = null;
          console.log(e);
        });
        this.expressionSrc = undefined;
        this.needPlayExpressionSound = false;
      }
    },
    replaySound() {
      this.$eventBus.$emit('StartReplay');
      this.replaySrc = undefined;
      this.needReplay = false;
    },
    mute() {
      this.baseAudio.volume = 0;
    },
  },
});
export default AudioPlayer;
